import React from 'react'
import { alpha, styled } from '@mui/material/styles'
import { Switch } from '@mui/material'

const ColorSwitches = ({ checked, onChange, colorMui, custom = false, ...rest }) => {
  const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase': {
      '&:hover': {
        backgroundColor: checked
          ? 'transparent'
          : alpha(colorMui[600], theme.palette.action.hoverOpacity),
      },
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: colorMui[400],
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: checked ? colorMui[400] : colorMui[100],
      opacity: !checked ? 1 : 0,
    },
    '& .MuiSwitch-track': {
      opacity: 1,
    },
  }))

  const SwitchMUI = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: colorMui[600],
      '&:hover': {
        backgroundColor: alpha(colorMui[600], theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: colorMui[600],
    },
  }))

  if (custom) return <CustomSwitch checked={checked} onChange={onChange} {...rest} />

  return <SwitchMUI checked={checked} onChange={onChange} {...rest} />
}

export default ColorSwitches
